/* eslint-disable no-restricted-imports */
import { BigNumber } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { ERRORS } from '../../../../Fct/errors';
import { FctAddress, FctPercent, FctValue, FctValue27 } from '../../../../Fct/generics';
import { getAssetRateByApy } from '../../../../Fct/plugins/AaveV2/helpers/getAssetRateByApy';
import { supportedContracts } from '../../../../Fct/plugins/Validator/constants';
export var ApyBetween = createPlugin({
    protocol: 'RADIANTV2',
    type: 'VALIDATOR',
    method: 'between',
    name: 'apyBetween',
    description: 'Check if a value is between two numbers',
    supportedContracts: supportedContracts,
    onCreate: function (_a) {
        var chainId = _a.chainId, input = _a.input;
        input.rateValue.subscribe({
            callback: function (_a) {
                var value = _a.value;
                input.methodParams.value.set({ value: value });
            },
            id: 'change_value1_on_rateValue_change',
        });
        input.methodParams.value.set({ value: input.rateValue.value });
        var setValue = function (_a) {
            var value = _a.value, param = _a.param;
            if (!value) {
                param.set({ value: undefined });
                return;
            }
            if (input.minApyValue.isVariable) {
                console.error('should be real value');
                return;
            }
            var rate = getAssetRateByApy({ apy: value });
            param.set({ value: rate.rate });
        };
        input.minApyValue.subscribe({
            callback: function (_a) {
                var value = _a.value;
                setValue({ value: value, param: input.methodParams.minValue });
            },
            id: 'change_minValue_on_minApyValue_change',
        });
        setValue({ value: input.minApyValue.value, param: input.methodParams.minValue });
        input.maxApyValue.subscribe({
            callback: function (_a) {
                var value = _a.value;
                setValue({ value: value, param: input.methodParams.maxValue });
            },
            id: 'change_maxValue_on_maxApyValue_change',
        });
        setValue({ value: input.maxApyValue.value, param: input.methodParams.maxValue });
    },
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            rateValue: new FctValue27({ mode: 'VARIABLE' }),
            minApyValue: new FctPercent({ destination: 'percent', mode: 'INPUT' }),
            maxApyValue: new FctPercent({ destination: 'percent', mode: 'INPUT' }),
            methodParams: {
                minValue: new FctValue({ readonly: true }),
                maxValue: new FctValue({ readonly: true }),
                value: new FctValue({ readonly: true }),
            },
        },
        output: {
            value: new FctValue({
                innerIndex: 0,
                description: 'Result of minValue subtraction from value',
            }),
        },
    }); },
    validate: function (params, errors) {
        var minValue = params.methodParams.minValue.value;
        var maxValue = params.methodParams.maxValue.value;
        if (typeof minValue === 'object')
            return true;
        if (typeof maxValue === 'object')
            return true;
        var minValueBN = BigNumber.from(minValue);
        var maxValueBN = BigNumber.from(maxValue);
        if (minValueBN.gt(maxValueBN)) {
            errors.set('minValue', ERRORS.RANGE_ERROR);
            return false;
        }
        errors.delete('minValue');
        return true;
    },
});
